import { getLocalStorage, setLocalStorage } from '@/utils/storage';

export enum NavigationActions {
  UPDATE_SHOW = 'navigation/SHOW',
  UPDATE_MODE = 'navigation/MODE',
  UPDATE_PAGE_TITLE = 'navigation/PAGE_TITLE',
}

export type NavMode = 'full' | 'rail' | 'closed';

export type NavigationType = {
  show: boolean;
  mode: NavMode;
  pageTitle: string;
};

const getInitialMode = (): NavMode => {
  try {
    const storedData = getLocalStorage('navigation');
    if (!storedData) return 'full';
    if (['full', 'rail', 'closed'].includes(storedData.mode)) {
      return storedData.mode;
    }
    return storedData.show === false ? 'closed' : 'full';
  } catch {
    return 'full';
  }
};

const initialMode = getInitialMode();

export const initialState: NavigationType = {
  show: initialMode !== 'closed',
  mode: initialMode,
  pageTitle: '',
};

const withMode = (state: NavigationType, mode: NavMode): NavigationType => {
  setLocalStorage('navigation', mode, 'mode');
  return { ...state, mode, show: mode !== 'closed' };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function reducer(state = initialState, action: any) {
  switch (action.type) {
    case NavigationActions.UPDATE_SHOW:
      return withMode(state, action.show ? 'full' : 'closed');
    case NavigationActions.UPDATE_MODE:
      return withMode(state, action.mode);
    case NavigationActions.UPDATE_PAGE_TITLE: {
      return {
        ...state,
        pageTitle: action.pageTitle,
      };
    }
    default:
      return state;
  }
}
